// 官网应用入口：挂载 Vue、ElementUI、路由
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import App from './App.vue'
import router from './router'

// 官网只用到 ElementUI 的基础组件（轮播、分页、输入框等），全局注册即可
Vue.use(ElementUI)
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
